export default "__VITE_ASSET__BhZ99dNP__"